import { createAction, props } from '@ngrx/store';
import { CompanyAddress } from '../_models/companyAddress';

// Action types
export const loadCompanyAddresses = createAction('[CompanyAddress] Load CompanyAddresses');
export const loadCompanyAddressesSuccess = createAction(
  '[CompanyAddress] Load CompanyAddresses Success',
  props<{ companyAddresses: CompanyAddress[] }>()
);
export const loadCompanyAddressesFailure = createAction(
  '[CompanyAddress] Load CompanyAddresses Failure',
  props<{ error: any }>()
);

export const addCompanyAddress = createAction(
  '[CompanyAddress] Add CompanyAddress',
  props<{ companyAddress: CompanyAddress }>()
);
export const addCompanyAddressSuccess = createAction(
  '[CompanyAddress] Add CompanyAddress Success',
  props<{ companyAddress: CompanyAddress }>()
);
export const addCompanyAddressFailure = createAction(
  '[CompanyAddress] Add CompanyAddress Failure',
  props<{ error: any }>()
);

export const updateCompanyAddress = createAction(
  '[CompanyAddress] Update CompanyAddress',
  props<{ companyAddress: CompanyAddress }>()
);
export const updateCompanyAddressSuccess = createAction(
  '[CompanyAddress] Update CompanyAddress Success',
  props<{ companyAddress: CompanyAddress }>()
);
export const updateCompanyAddressFailure = createAction(
  '[CompanyAddress] Update CompanyAddress Failure',
  props<{ error: any }>()
);

export const deleteCompanyAddress = createAction(
  '[CompanyAddress] Delete CompanyAddress',
  props<{ id: number }>()
);
export const deleteCompanyAddressSuccess = createAction(
  '[CompanyAddress] Delete CompanyAddress Success',
  props<{ id: number }>()
);
export const deleteCompanyAddressFailure = createAction(
  '[CompanyAddress] Delete CompanyAddress Failure',
  props<{ error: any }>()
);
